import { memo } from 'react';
import { SxProps, Theme } from '@mui/material';
import Box from '../Box';
import Tooltip, { ITooltipProps } from '../Tooltip';
import Typography, { ITypographyProps } from '../Typography';

export interface ITypographyWithTooltip extends Omit<ITypographyProps, 'children'> {
  title?: string;
  children: ITypographyProps['children'];
  tooltipProps?: Partial<ITooltipProps>;
  breakWord?: boolean;
  cursorPointer?: boolean;
  cursor?: string;
}

interface IBuildSXParams {
  lineClamp: ITypographyProps['lineClamp'];
  breakWord: boolean;
  cursorPointer: boolean;
  cursor: string;
}

const buildSX = ({
  lineClamp, breakWord, cursorPointer, cursor,
}: IBuildSXParams): SxProps<Theme> => ({
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: lineClamp,
  wordBreak: breakWord ? 'break-all' : null,
  cursor: cursorPointer ? 'pointer' : cursor,
});

const TypographyWithTooltip = (props: ITypographyWithTooltip) => {
  const {
    title,
    children,
    breakWord = false,
    tooltipProps = {},
    lineClamp = 1,
    cursorPointer = false,
    cursor = 'auto',
    ...restTypographyProps
  } = props;
  return (
    <Typography component="div" {...restTypographyProps}>
      <Tooltip title={title ?? children ?? ''} followCursor {...tooltipProps}>
        <Box sx={buildSX({
          lineClamp, breakWord, cursorPointer, cursor,
        })}
        >
          {children}
        </Box>
      </Tooltip>
    </Typography>
  );
};

export default memo(TypographyWithTooltip);
